import { RequestAppointmentModel } from '../models/request-appointment';
import api from './api';

export const requestAppointment = async (requestAppointmentModel: RequestAppointmentModel) => {
  return await api.post('/appointments', requestAppointmentModel);
};
